module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Boezberg-efa9ceb968cc669e231e73a2edf46c0a.png";